(function($, undefined) {
	
	'use strict';
	
	var checkForExplorerDownload = function () {
		//If IE11
		if (!!window.MSInputMethodContext && !!document.documentMode) {
			$('[download]').removeAttr('download').attr('target', '_blank');
		}
	};
	
	
	var init = function () {
		checkForExplorerDownload();
	};
	
	
	$(window).ready(function () {
		init();
	});
	
})(jQuery);
